import PlanCard from "./PlanCard";
import { Plan } from "../../interfaces/Plan";
import "./pricing.css";

const Pricing = () => {
  const plans: Plan[] = [
    {
      title: "basic",
      price: "24,999",
      details: {
        cms: "Wordpress Site",
        theme: "Free Theme",
        plugin: "Free Plugin",
        domain: "No Domain",
        hosting: "No Hosting",
        support: "3 Days Free Service",
        message: "No Message Integration",
        payment: "COD + bKash/Rocket (Manual)",
        products: "10 Products by Default",
        training: "30 Minutes Free Training",
      },
    },
    {
      title: "professional",
      price: "49,999",
      details: {
        cms: "Wordpress Site",
        theme: "Paid Theme",
        plugin: "Free Plugin",
        domain: "No Domain",
        hosting: "No Hosting",
        support: "15 Days Free Service",
        message: "No Message Integration",
        payment: "Manual + Card + bKash Merchant",
        products: "25 Products by Default",
        training: "2 Hours Free Training",
      },
    },
    {
      title: "master",
      price: "99,999",
      details: {
        cms: "Wordpress Site",
        theme: "Paid Theme",
        plugin: "Paid Basic Plugin",
        domain: "No Domain",
        hosting: "No Hosting",
        support: "30 Days Free Service",
        message: "Message Integration",
        payment: "SSLCommerz (Charged)",
        products: "50 Products by Default",
        training: "5 Hours Free Training",
      },
    },
  ];

  return (
    <div className="wrapper" id="pricing">
      <h1 className="main-title">Our Pricing</h1>
      <div className="plans-wrapper">
        {plans.map((plan) => (
          <PlanCard key={plan?.title} {...plan} />
        ))}
      </div>
    </div>
  );
};

export default Pricing;
